import { render, staticRenderFns } from "./ImageFull.vue?vue&type=template&id=8509601a&scoped=true&"
import script from "./ImageFull.vue?vue&type=script&lang=js&"
export * from "./ImageFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8509601a",
  null
  
)

export default component.exports